"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.download = void 0;
var http_1 = require("../helpers/http");
var index_1 = require("../index");
var helpers_1 = require("../helpers/helpers");
var messages_1 = require("../constants/messages");
var core_1 = require("./core");
/**
 * Start a HTTP Gateway download. Progress is not provided on downloads, browser handles download directly
 * When in software mode the promise will return transfer_spec_id and the URL. The URL has not been used
 * therefore a client can open it and start the download using software specific methods (like file reader).
 *
 * @param transferSpec standard Connect transferSpec for downloading
 *
 * @returns a promise that resolves if download is started successfully or rejects if error occurs
 */
var download = function (transferSpec, options) {
    if (options === void 0) { options = {}; }
    if (!index_1.asperaHttpGateway.isReady) {
        (0, helpers_1.errorLog)(messages_1.messages.serverNotVerified);
        return new Promise(function (resolve, reject) {
            reject((0, helpers_1.generateErrorBody)(messages_1.messages.serverNotVerified));
        });
    }
    if (!(0, helpers_1.isValidTransferSpec)(transferSpec)) {
        (0, helpers_1.errorLog)(messages_1.messages.notValidTransferSpec);
        return new Promise(function (resolve, reject) {
            reject((0, helpers_1.generateErrorBody)(messages_1.messages.notValidTransferSpec, { transferSpec: transferSpec }));
        });
    }
    var promiseInfo = (0, helpers_1.generatePromiseObjects)();
    if (typeof options.zipRequire === 'boolean') {
        transferSpec.zip_required = options.zipRequire;
    }
    var payload = {
        transfer_spec: transferSpec
    };
    var finalServerUrl = options.serverUrlOverride ? (0, core_1.cleanupServerUrl)(options.serverUrlOverride) : index_1.asperaHttpGateway.globals.serverUrl;
    (0, http_1.apiPost)("".concat(finalServerUrl, "/v1/download"), payload).then(function (response) {
        response.json().then(function (data) {
            if (data.transfer_spec_id) {
                var downloadUrl = "".concat(finalServerUrl, "/v1/download/").concat(data.transfer_spec_id);
                if (index_1.asperaHttpGateway.globals.softwareMode || (options === null || options === void 0 ? void 0 : options.disableAutoDownload)) {
                    promiseInfo.resolver({
                        transfer_spec_id: data.transfer_spec_id,
                        url: downloadUrl,
                    });
                    return;
                }
                index_1.asperaHttpGateway.globals.triggerDownloadFromUrl(downloadUrl);
                promiseInfo.resolver();
            }
            else {
                (0, helpers_1.errorLog)(messages_1.messages.failedToGetDownloadUrl, { response: data });
                promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.failedToGetDownloadUrl, { response: data }));
            }
        });
    }).catch(function (error) {
        (0, helpers_1.errorLog)(messages_1.messages.downloadFailed, error);
        promiseInfo.rejecter((0, helpers_1.generateErrorBody)(messages_1.messages.downloadFailed, error));
    });
    return promiseInfo.promise;
};
exports.download = download;
exports.default = {
    download: exports.download
};
